"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.createWrappedComponent = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["children"];
var createWrappedComponent = exports.createWrappedComponent = function createWrappedComponent(Component) {
  var WrapperComponent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var WrappedComponent = function WrappedComponent(props) {
    var children = props.children,
      otherProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
    return WrapperComponent ? /*#__PURE__*/_react["default"].createElement(WrapperComponent, null, /*#__PURE__*/_react["default"].createElement(Component, otherProps, children)) : /*#__PURE__*/_react["default"].createElement(Component, otherProps, children);
  };
  WrappedComponent.propTypes = {
    children: _propTypes["default"].node
  };
  WrappedComponent.defaultProps = {
    children: null
  };
  return WrappedComponent;
};
var _default = exports["default"] = {
  createWrappedComponent: createWrappedComponent
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-composed-components/lib/featured/utils/wrapperUtils.js
// module id = 1712
// module chunks = 25